import { memo, useCallback } from 'react';
import { AppBar, Toolbar } from '@mui/material';
import { StyleObj } from '../../@types';

import { SPORTSBOOK_HEADER_HEIGHT } from '../../config/skinRegistry/configs';
import SearchBar from './SearchBar';
import ToolbarContent from './ToolbarContent';

type HeaderProps = {
  isDrawerOpen?: boolean;
  isSidebarCompact?: boolean;
  showSidebarCollapse?: boolean;
  toggleDrawerVisibility?: (isOpen: boolean) => void;
  toggleSidebarCompact?: () => void;
};

const styles: StyleObj = {
  appBar: {
    height: { xs: 'fit-content', md: SPORTSBOOK_HEADER_HEIGHT },
    backgroundColor: 'primary.600',
  },
  toolbar: {
    width: '100%',
    minHeight: SPORTSBOOK_HEADER_HEIGHT,
    justifyContent: 'space-between',
    px: { xs: 1, md: 2 },
  },
};

const Header = memo(({ toggleDrawerVisibility }: HeaderProps) => {
  const openDrawer = useCallback(() => {
    toggleDrawerVisibility?.(true);
  }, [toggleDrawerVisibility]);

  return (
    <AppBar position='fixed' elevation={0} sx={styles.appBar}>
      <Toolbar sx={styles.toolbar}>
        <SearchBar />
        <ToolbarContent openDrawer={openDrawer} />
      </Toolbar>
    </AppBar>
  );
});

export default Header;
